export const windowsScriptDocs = {
  ps5: [
    { label: "SpringBoot" },
    { label: "Flask" },
    { label: "React" },
    { label: "Angular" },
    { label: "React + Spring Boot" },
    { label: "Angular + Spring Boot" },
  ],
  ps7: [
    { label: "SpringBoot" },
    { label: "Flask" },
    { label: "React" },
    { label: "Angular" },
    { label: "React + Spring Boot" },
    { label: "Angular + Spring Boot" },
  ],
  linux: [
    { label: "SpringBoot" },
    { label: "Flask" },
    { label: "React" },
    { label: "Angular" },
    { label: "React + Spring Boot" },
    { label: "Angular + Spring Boot" },
  ],
};
